import firebase from "firebase"
import { SongModel } from "models/SongModel";
import { AudioProject } from "Project";

export const getSong = async (id: string): Promise<SongModel|null> => {
    const db = firebase.firestore();
    const songRef = await db.collection("songs")
      .doc(id)
      .get()

    if (!songRef.exists) {
        return null;
    }
    return songRef.data() as SongModel;
};

export const getSongAlbumArt = async (song: SongModel): Promise<string> => {
    if (song.gifURL) {
        return song.gifURL;
    }
    return firebase
        .storage()
        .ref(`albumArt/${song.songID}`)
        .getDownloadURL()
        .catch(() => {
            return "";
        })
};

export const getSongPlaybackUrl = async (songId: string): Promise<string|null> => {
    return firebase
        .storage()
        .ref(`songs/${songId}`)
        .getDownloadURL()
        .catch(() => {
            return null;
        });
};

export const getAllSongStems = async (songId: string, audioProject: AudioProject|null) => {
    return firebase.storage().ref(`songStems/${songId}`)
        .listAll()
        .then(async (res) => {
            const nonStemFilesFromProject = audioProject?.tracks
                .flatMap((track) => track.clips)
                .map((clip) => clip.remotePath || clip.url)
                .filter((url) => !url.includes(songId)) || [];
            const stemFilePromises = res.items.map(item => item.getDownloadURL());
            const nonStemFilesPromises = nonStemFilesFromProject.map((url) => {
                return firebase.storage().ref(url).getDownloadURL();
            });
            const urls = await Promise.all(stemFilePromises.concat(nonStemFilesPromises));
            const names = res.items.map((item) => item.name).concat(nonStemFilesFromProject);
            return urls
                .map((url, i) => ({ url, filename: names[i] }));
        });
};

export const getAudioProject = async (songId: string) => {
    return firebase.storage().ref(`songStems/${songId}/project.pb`)
        .getDownloadURL()
        .then(fetch)
        .then(res => res.arrayBuffer())
        .then(buffer => {
            return AudioProject.decode(Buffer.from(buffer));
        }).catch(() => {
            console.warn("No project file found.")
            return null;
        });
};
